import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const expenseBreakdownSchema = z.object({
  total: z.number(),
  average: z.number(),
});

const expenseCohortSchema = z.object({
  type: z.string(),
  entityCount: z.number().int().min(0),
  total: z.number(),
  average: z.number(),
  byType: z.record(z.string(), expenseBreakdownSchema),
});

export const getSupportConversationExpenseCohorts = unaryRpc({
  name: "getSupportConversationExpenseCohorts" as const,
  input: z.object({
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    teamIds: z.array(zExt.objectId("teams")).optional(),
    currency: z.string().optional(),
  }),
  output: z.object({ cohorts: z.array(expenseCohortSchema) }),
});

export type GetSupportConversationExpenseCohortsOutput = z.infer<
  typeof getSupportConversationExpenseCohorts.output
>;
